import { GetPrograms, Program, UserData, UserDate, UserState, UserDecimalSep, UserCsvSep } from 'models/user';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: UserState = {
  userData: null,
  loggedInStatus: false,
  userPrograms: null,
  menuPrograms: null,
};

export const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuthData: (state, { payload }: PayloadAction<UserData>) => {
      state.userData = payload;
    },
    setUserAuthStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.loggedInStatus = payload;
    },
    setUserPrograms: (state, { payload }: PayloadAction<GetPrograms>) => {
      state.userPrograms = payload;
    },
    setMenuPrograms: (state, { payload }: PayloadAction<Program[]>) => {
      state.menuPrograms = payload;
    },
    setUserImage: (state, { payload }: PayloadAction<string>) => {
      state.userData && (state.userData.userImage = payload);
    },
    setSendMail: (state, { payload }: PayloadAction<0 | 1>) => {
      state.userData && (state.userData.sendMail = payload);
    },
    setUserDateFormat: (state, { payload }: PayloadAction<UserDate>) => {
      state.userData && (state.userData.preferredDateFormat = payload);
    },
    setUserDaecimalSep: (state, { payload }: PayloadAction<UserDecimalSep>) => {
      state.userData && (state.userData.decimalSeparator = payload);
    },
    setUserCsvSep: (state, { payload }: PayloadAction<UserCsvSep>) => {
      state.userData && (state.userData.csvSeparator = payload);
    },
    setUserTimezone: (state, { payload }: PayloadAction<string>) => {
      state.userData && (state.userData.timeZone = payload);
    },
    setOpenNextDocument: (state, { payload }: PayloadAction<boolean>) => {
      state.userData && (state.userData.openNextDocument = payload);
    },
    setUserLogout: () => initialState,
    setOpenInvoiceLogAuto: (state, { payload }: PayloadAction<boolean>) => {
      state.userData && (state.userData.openInvoiceLogAutomatically = payload);
    },
    setOpenPreviousApprover: (state, { payload }: PayloadAction<boolean>) => {
      state.userData && (state.userData.openPreviousApprover = payload);
    }
  },
});

export default slice.reducer;
